// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ship-to[data-v-5707e12d]{grid-area:ship-to}@media(max-width:767px){.ship-to[data-v-5707e12d]{align-self:flex-start}}", ""]);
// Exports
module.exports = exports;
